export default "__VITE_ASSET__30be544f__"